import { useState } from "react";
import {
  Navbar,
  Container,
  Nav,
  Offcanvas,
  NavDropdown,
} from "react-bootstrap";
import { NavLink } from "react-router-dom";
import "./header.css";
import logo from "../assets/images/icsaj.png";

export default function Header() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      {/* TOP NAVBAR */}
      <Navbar
        expand="lg"
        variant="dark"
        sticky="top"
        className="main-navbar"
        style={{
          background: "linear-gradient(90deg, #c72800ff, #bd3e03ff)",
          height: "90px",
          marginTop: "0",
        }}
      >
        <Container>
          {/* LOGO */}
          <Navbar.Brand
            as={NavLink}
            to="/"
            className="logo"
            style={{ color: "white" }}
          >
            <img src={logo} alt="ICSAJ" />
          </Navbar.Brand>

          {/* HAMBURGER */}
          <Navbar.Toggle onClick={handleShow} />

          {/* DESKTOP MENU */}
          <Nav className="ms-auto d-none d-lg-flex gap-4 align-items-center">
            <Nav.Link as={NavLink} to="/">
              Home
            </Nav.Link>

            <Nav.Link as={NavLink} to="/about">
              About
            </Nav.Link>

            {/* Get Involved DROPDOWN */}
            <NavDropdown
              title="Get Involved"
              id="Get-Involved-dropdown"
              className="hover-dropdown"
            >
              <NavDropdown.Item as={NavLink} to="/Get-Involved/legal-advocacy">
                LegalAdvocacy
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/Get-Involved/advocate-for-sanatana-rights"
              >
                Advocate for Sanatana Rights
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/Get-Involved/volunteer-with-us"
              >
                Volunteer With Us
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/Get-Involved/research">
                Legal & Research Collaboration
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/Get-Involved/report">
                Report Issues & Violations
              </NavDropdown.Item>
            </NavDropdown>

            {/* GALLERY DROPDOWN */}
            {/* <NavDropdown
              title="Gallery"
              id="gallery-dropdown"
              className="hover-dropdown"
            >
              <NavDropdown.Item as={NavLink} to="/videos">
                Videos
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/events">
                Photos
              </NavDropdown.Item>
            
            </NavDropdown> */}

            <Nav.Link as={NavLink} to="/blogs">
              Blogs
            </Nav.Link>

            <Nav.Link as={NavLink} to="/contact">
              Contact Us
            </Nav.Link>
          </Nav>
        </Container>
      </Navbar>

      {/* MOBILE OFFCANVAS */}
      <Offcanvas
        show={show}
        onHide={handleClose}
        placement="start"
        className="mobile-drawer"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <img src={logo} alt="ICSAJ" height="40" />
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <Nav className="flex-column gap-3">
            <Nav.Link as={NavLink} to="/" onClick={handleClose}>
              Home
            </Nav.Link>

            <Nav.Link as={NavLink} to="/about" onClick={handleClose}>
              About
            </Nav.Link>

            {/* MOBILE Get Involved */}
            <NavDropdown title="Get Involved">
              <NavDropdown.Item
                as={NavLink}
                to="/Get-Involved/legal-advocacy"
                onClick={handleClose}
              >
                Legal Advocacy
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/Get-Involved/education"
                onClick={handleClose}
              >
                Education & Training
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/Get-Involved/legal-aid"
                onClick={handleClose}
              >
                Legal Aid & Social Justice
              </NavDropdown.Item>
              <NavDropdown.Item
                as={NavLink}
                to="/Get-Involved/research"
                onClick={handleClose}
              >
                Policy & Research
              </NavDropdown.Item>
            </NavDropdown>

            {/* MOBILE GALLERY */}
            {/* <NavDropdown title="Gallery">
              <NavDropdown.Item as={NavLink} to="/events" onClick={handleClose}>
                Photos
              </NavDropdown.Item>
              <NavDropdown.Item as={NavLink} to="/videos" onClick={handleClose}>
                Videos
              </NavDropdown.Item>
            </NavDropdown> */}

            <Nav.Link as={NavLink} to="/blogs" onClick={handleClose}>
              Blogs
            </Nav.Link>

            <Nav.Link as={NavLink} to="/contact" onClick={handleClose}>
              Contact
            </Nav.Link>
          </Nav>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
